// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import SessionActions from 'agent_portal/actions/SessionActions';
import DropdownMenu, { DropdownTrigger, DropdownContent } from '../DropdownMenu';
import Icon from 'shared/components/Icon';
import classes from './UserDropdown.module.scss';
import DefaultProfileImagePath from './assets/default.avatar.png';

const UserDropdown = ({ name, profileImagePath, showSubscriptionLink, providerId }) => (
  <div className={classes.user_dropdown}>
    <DropdownMenu>
      <DropdownTrigger>
        <div className={classes.dropdown_trigger}>
          <img src={profileImagePath} alt="profile" />
          <span>
            {name} <Icon name="chevron-down" />
          </span>
        </div>
      </DropdownTrigger>
      <DropdownContent>
        <div>
          <ul>
            {providerId ? (
              <li>
                <Link to={`/a/portal/providers/${providerId}/profile`}>My Profile</Link>
              </li>
            ) : null}
            <li>
              <Link to="/a/portal/current_agent/edit">Personal Settings</Link>
            </li>
            {showSubscriptionLink ? (
              <li>
                <Link to="/a/portal/subscribe">Organization Subscription</Link>
              </li>
            ) : null}
            <li>
              <a id="logout" onClick={SessionActions.signOutAgent}>
                Log Out
              </a>
            </li>
          </ul>
        </div>
      </DropdownContent>
    </DropdownMenu>
  </div>
);

UserDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  profileImagePath: PropTypes.string.isRequired,
  showSubscriptionLink: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  const { currentAgent } = state;
  const showSubscriptionLink =
    currentAgent.currentEmployment.features.indexOf('manage_subscription') >= 0 &&
    currentAgent.currentEmployment.showSubscriptionLink;

  return {
    name: `${currentAgent.firstName} ${currentAgent.lastName}`,
    profileImagePath: currentAgent.currentEmployment.profileImagePath || DefaultProfileImagePath,
    providerId: currentAgent.currentEmployment.providerId,
    showSubscriptionLink,
  };
}

export default connect(mapStateToProps)(UserDropdown);
